import { ChevronDown } from 'lucide-react';

import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { TERMOS_E_CONDICOES_TEXT } from '@/constants/termosCondicoes';

export function TermosCondicoesModal() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          type="button"
          className="inline text-[#ff2d6c] hover:underline font-semibold text-xs"
        >
          Termos e Condições <ChevronDown size={12} className="inline ml-1" />
        </button>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        className="max-h-[85vh] overflow-y-auto bg-white"
      >
        <div className="max-w-2xl mx-auto py-6 px-4 bg-white">
          <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-1">
            {TERMOS_E_CONDICOES_TEXT.titulo}
          </h2>
          <p className="text-xs text-slate-500 mb-6 font-semibold">
            Última atualização: {TERMOS_E_CONDICOES_TEXT.dataAtualizacao}
          </p>

          <div className="space-y-5 text-xs text-slate-800 leading-relaxed">
            {TERMOS_E_CONDICOES_TEXT.secoes.map((secao) => (
              <section key={secao.numero} className="bg-white">
                <h3 className="font-black text-slate-900 uppercase tracking-wider mb-2 text-xs">
                  {secao.numero}. {secao.titulo}
                </h3>
                <ul className="space-y-1.5 list-none">
                  {secao.itens.map((item, idx) => (
                    <li key={idx} className="flex gap-2">
                      <span className="text-[#ff2d6c] flex-shrink-0 mt-0.5 font-bold">
                        •
                      </span>
                      <span className="text-slate-800">{item}</span>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
